var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-page',{attrs:{"title":"取消订单"}},[_c('x-result',{attrs:{"title":"订单取消成功","confirm-text":"订单列表","guess-resource-position-id":"8aaa92be7b66c738017b77a0149900c8","confirm-track":{
      name: '取消订单-订单列表',
      id: 'fc604888-cfee-4526-870f-b7e50123e5e1',
    }},on:{"confirm":_vm.handleConfirmClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }